import { Link } from 'react-router-dom';
import { HelpCircle, FileText, ShoppingCart } from 'lucide-react';
import MagicHeader from '../../widgets/MagicHeader';
import ProfileCard from '../../widgets/ProfileCard';
import '../magic.css';

const Profile = () => {
  return (
    <div className="magic-theme-light">
      <MagicHeader variant="light" showBack onBack={() => window.history.back()} hideActions />
      <main className="page-content strict-width x-space-top">
        <h4 className="title mb-3">Profile</h4>
        <ProfileCard />

        <div className="profile-links">
          <Link to="/cart">
            <ShoppingCart size={16} className="me-2" /> My Moments
          </Link>
          <Link to="/faqs">
            <HelpCircle size={16} className="me-2" /> FAQs
          </Link>
          <Link to="/terms-and-conditions">
            <FileText size={16} className="me-2" /> Terms & Conditions
          </Link>
        </div>
      </main>
    </div>
  );
};

export default Profile;
